<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/JshL7Z/tc-custom/9780062006790.jpg?1729938043750" alt="This image is the cover for the book Blessings of the Animals"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Blessings of the Animals
      </h1>
      <p class="bookDescription body article font2">
        <b>“Beautifully crafted. . . . A must-read not only for animal lovers, but for anyone who has found the courage to come back from heartbreak and find love again.” —Sara Gruen, <i>New York Times</i>–bestselling author of <i>Water for Elephants</i></b><br/><br/>From Katrina Kittle, critically acclaimed author of <i>The Kindness of Strangers</i>, comes a wry and moving novel of forgiveness, flexibility, happiness, and the art of moving on.<br/><br/>Veterinarian Cami Anderson has hit a rough patch. Stymied by her recent divorce, she wonders if there are secret ingredients to a happy, long-lasting marriage or if the entire institution is outdated and obsolete. Couples all around her are approaching important milestones. Her parents are preparing to celebrate their fiftieth anniversary. Her brother and his partner find their marriage dreams legally blocked. Her former sister-in-law—still her best friend—is newly engaged. The youthfully exuberant romance of her teenage daughter is developing complications. And three separate men—including her ex-husband—are becoming entangled in Cami's messy post-marital love life.<br/><br/>But as she struggles to come to terms with her own doubts amid this chaotic circus of relationships, Cami finds strange comfort in an unexpected confidant: an angry, unpredictable horse in her care. With the help of her equine soul mate, she begins to make sense of marriage's great mysteries—and its disconnects.<br/><br/>“A marvelous page-turner, a story of an unexpected heartbreak and the unexpected blessings that result. I didn’t want to put this book down!”—Ellen Baker, author of <i>Keeping the House</i><br/><br/>“Wonderfully poignant characters and a deeply satisfying exploration of love in its many incarnations . . . make this novel Katrina Kittle’s most insightful yet.” —Lesley Kagen, <i>New York Times</i>–bestselling author of <i>Tomorrow River</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Katrina Kittle
      </h2>
      
      <p class="authorDescription body article"><P>Katrina Kittle is the author of <I>Traveling Light</I>, <I>Two Truths and a Lie</I>, and <I>The Kindness of Strangers</I>, which received the Great Lakes Book Award for Fiction. She lives in Dayton, Ohio.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      HarperCollins
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5d35c789